<div class="upload-popup-overlay" *ngIf="isVisible" (click)="onBackdropClick($event)">
  <div class="upload-popup-container">
    <div class="upload-popup-header">
      <h3>上傳測試數據</h3>
      <button class="close-btn" (click)="closePopup()" [disabled]="isUploading">×</button>
    </div>

    <div class="upload-popup-content">
      <!-- Initial State -->
      <div *ngIf="uploadStep === 'initial'" class="upload-step">
        <div class="participant-info">
          <p><strong>參與者識別碼:</strong> {{ participantIdentifier }}</p>
        </div>
        <p class="upload-description">
          點擊下方按鈕開始上傳測試數據到雲端資料庫
        </p>
        <button class="upload-btn primary" (click)="startUpload()">
          開始上傳 (Start Upload)
        </button>
      </div>

      <!-- Uploading State -->
      <div *ngIf="uploadStep === 'uploading'" class="upload-step">
        <div class="loading-container">
          <div class="spinner"></div>
          <p>正在上傳數據，請稍候... (Uploading data, please wait...)</p>
        </div>
      </div>

      <!-- Rename State -->
      <div *ngIf="uploadStep === 'rename'" class="upload-step">
        <div class="error-message">
          <p>⚠️ 參與者識別碼 "{{ participantIdentifier }}" 已存在</p>
          <p>請輸入新的識別碼:</p>
        </div>
        <div class="rename-input-container">
          <input 
            type="text" 
            [(ngModel)]="newParticipantIdentifier" 
            placeholder="輸入新的參與者識別碼"
            class="rename-input"
            [disabled]="isUploading">
          <button 
            class="upload-btn primary" 
            (click)="retryWithNewName()"
            [disabled]="isUploading || !newParticipantIdentifier.trim()">
            重新上傳 (Retry Upload)
          </button>
        </div>
        <p class="error-text" *ngIf="uploadError">{{ uploadError }}</p>
      </div>

      <!-- Success State -->
      <div *ngIf="uploadStep === 'success'" class="upload-step">
        <div class="success-message">
          <div class="success-icon">✅</div>
          <h4>上傳成功!</h4>
          <p>數據已成功上傳到雲端資料庫</p>
          <p class="auto-close-note">視窗將自動關閉...</p>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="uploadStep === 'error'" class="upload-step">
        <div class="error-message">
          <div class="error-icon">❌</div>
          <h4>上傳失敗</h4>
          <p class="error-text">{{ uploadError }}</p>
          
          <!-- Show login button if authentication expired -->
          <div *ngIf="uploadError.includes('Authentication expired') || uploadError.includes('log in again')" class="auth-actions">
            <button class="upload-btn primary" (click)="login()">
              重新登入
            </button>
          </div>
          
          <button class="upload-btn secondary" (click)="closePopup()">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
